const Config = require("../Config/Config");

function fetchWithTimeout(url, options, timeoutMS = 5000) {
  return Promise.race([
    fetch(url, options),
    new Promise(function (_, reject) {
      setTimeout(function () {
        reject(new Error("Request timed out"))
      }, timeoutMS)
    })
  ])
}

function validateDisplayId( id ) {
  if (!id) {return Promise.reject(Error("Missing id"));}

  const url = new URL("validateDisplayId", Config.MESSAGING_SERVER_URL);
  url.searchParams.set("displayId", id);

  return fetchWithTimeout(url.toString())
  .then(resp=>resp.status === 204 ? id :
    resp.status === 404 ? Promise.reject(Error("Invalid id")) :
    Promise.reject(Error("Display ID response error")));
}

function createDisplayIdFromClaimId( name, id ) {
  if (!name) {return Promise.reject(Error("Missing Display Name"))}

  const claimIdPath = "/v2/viewer/display/DID/register?name=NM";
  const url = Config.SERVER_URL.concat(claimIdPath).replace("DID", id).replace("NM", name);

  try {
    localStorage.setItem("webplayer-claim-id", id);
  } catch(e) {console.log(e)}

  return fetch(url)
  .then(resp=>resp.ok ? resp.json() : Promise.reject(Error("Claim ID response error")))
  .then(json=>{
    if (!json || !json.status || json.status.code !== 0 || json.error) {
      const errorMessage = (json && json.status && json.status.message) || "Claim ID error";
      return Promise.reject(Error(errorMessage));
    }

    return json.displayId;
  });
}

module.exports = { validateDisplayId, createDisplayIdFromClaimId };
